import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-career-coaches',
  imports: [PillarPagesTemp],
  templateUrl: './career-coaches.html',
  styleUrl: './career-coaches.scss',
})
export class CareerCoaches {

}
